import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { electricalData } from './UCCSubcodeJsonData/electricalData'
import { buildingData } from './UCCSubcodeJsonData/buildingData'
import { fireData } from './UCCSubcodeJsonData/fireData';
import { chimneyData } from './UCCSubcodeJsonData/chimneyData';
import { mechanicalData } from './UCCSubcodeJsonData/mechanicalData';
import { plumbingData } from './UCCSubcodeJsonData/plumbingData';

const initialState = {
  formData: null,
  AppId: 0,
  Building: buildingData,
  Electrical: electricalData,
  Fire: fireData,
  Chimney: chimneyData,
  Mechanical: mechanicalData,
  Plumbing: plumbingData
}

// Helper to check if value is an object
const isObject = (item: any): boolean => {
  return item && typeof item === 'object' && !Array.isArray(item);
};

// Helper function for deep merging objects
const deepMerge = (target: any, source: any) => {
  const output = { ...target };

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          output[key] = deepMerge(target[key], source[key]);
        }
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }

  return output;
};

const constructionFormSlice = createSlice({
  name: 'applicationForm',
  initialState,
  reducers: {
    updateFormData: (state, action: PayloadAction<any>) => {
      state.formData = {
        ...state.formData,
        ...action.payload
      };
    },
    updateBuilding: (state, action: PayloadAction<any>) => {
      state.Building = deepMerge(state.Building, action.payload);
    },
    updateElectrical: (state, action: PayloadAction<any>) => {
      state.Electrical = deepMerge(state.Electrical, action.payload);
    },
    updateFire: (state, action: PayloadAction<any>) => {
      state.Fire = deepMerge(state.Fire, action.payload);
    },
    updateChimney: (state, action: PayloadAction<any>) => {
      state.Chimney = deepMerge(state.Chimney, action.payload);
    },
    updateMechanical: (state, action: PayloadAction<any>) => {
      state.Mechanical = deepMerge(state.Mechanical, action.payload);
    },
    updatePlumbingCharacteristics: (state, action) => {
      state.Plumbing.PlumbingCharacteristics = {
        ...state.Plumbing.PlumbingCharacteristics,
        ...action.payload,
      };
    },
    updatePlumbing: (state, action: PayloadAction<any>) => {
      // Use deep merge to handle nested updates properly
      state.Plumbing = deepMerge(state.Plumbing, action.payload);
    },
    updateAppId: (state, action: PayloadAction<any>) => {
      state.AppId = action.payload.applicationId
    },
    resetFormData: (state) => {
      state.formData = null;
      state.Building = initialState.Building;
      state.Electrical = initialState.Electrical;
      state.Fire = initialState.Fire;
      state.Chimney = initialState.Chimney;
      state.Plumbing = initialState.Plumbing;
      state.Mechanical = initialState.Mechanical;
      state.AppId = 0
    },
    resetUccForm: (state) => {
      state.Building = initialState.Building;
      state.Electrical = initialState.Electrical;
      state.Fire = initialState.Fire;
      state.Chimney = initialState.Chimney;
      state.Plumbing = initialState.Plumbing;
      state.Mechanical = initialState.Mechanical;
    }
  }
});

export const {
  updateFormData,
  resetFormData,
  updateBuilding,
  updateElectrical,
  updateFire,
  updateChimney,
  updateMechanical,
  updatePlumbing,
  updatePlumbingCharacteristics,
  updateAppId,
  resetUccForm
} = constructionFormSlice.actions;
export default constructionFormSlice.reducer;